// extracted by mini-css-extract-plugin
export var mainContainer = "mainLayout-module--mainContainer--+GBE2";
export var backgroundWire = "mainLayout-module--backgroundWire--hAMq6";